// Blog products
$('document').ready(function () {
  if ($('[data-blog-products]').length > 0) {
    var url = $('[data-blog-products]').attr('data-url');
    var container = $('[data-blog-products]');

    $.get(url, function (data) {
      var products = data.products;
      $.each(products, function (index, product) {
        var productWrap = $('<div>')
          .append($('.product-html').find('.product').first().clone())
          .html()
          .replace('inf_id_here', product.id);
        container.append(productWrap);
        var productObject = $('.products').find('.inf-product[data-inf-id="' + product.id + '"]');
        fillProduct(product, productObject);
      });
    }).done(function () {
      $('.blog-products-slider').owlCarousel({
        autoplayHoverPause: true,
        lazyLoad: true,
        loop: false,
        margin: 0,
        nav: true,
        navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
        dots: false,
        responsive: {
          0: {
            items: 2,
          },
          768: {
            items: 3,
          },
        },
      });
    });
  }
  // End blog products //
});

function fillProduct(product, productObject) {
  var wishlistUrl = basicUrl + 'account/wishlistAdd/' + product.id;
  var compareAddUrl = basicUrl + 'compare/add/' + product.vid + '/';
  var compareDelUrl = basicUrl + 'compare/delete/' + product.vid + '';
  var img_size = productObject.data('img-size');
  if (product.image) {
    var imageUrl = product.image.replace('50x50x2', img_size);
  }
  var plainImage = product.image.replace('/50x50x2/', '/');
  var labelText = '';

  productObject.addClass('col-xs-12 ' + product.id + '');
  productObject.attr({ 'data-id': product.id, 'data-url': product.url });
  productObject.find('[data-infinite-product-url]').attr({ href: product.url, title: product.title });
  productObject
    .find('[data-infinite-product-image]')
    .attr({
      src: imageUrl,
      'data-src': imageUrl,
      'data-srcset': imageUrl + ' 1x',
      title: product.title,
      alt: product.title,
      width: '100%',
    })
    .removeClass('lazy');
  productObject
    .find('[data-infinite-product-title]')
    .attr({ href: product.url, title: product.title })
    .html(product.title);

  // Prices
  productObject.find('[data-infinite-product-price-wrap] .price-new').html(money(product.price.price));
  if (product.price.price_old) {
    productObject
      .find('[data-infinite-product-price-wrap]')
      .prepend('<div class="price-old">' + money(product.price.price_old) + '</div>');
  }

  productObject.find('.sec').remove();

  // Compare
  productObject.find('.compare').attr('for', 'add_compare_' + product.id);
  productObject.find('.compare input').attr('id', 'add_compare_' + product.id);
  productObject.find('.compare label').attr('for', 'add_compare_' + product.id);
  productObject.find('.compare, .compare input').attr('data-add-url', compareAddUrl);
  productObject.find('.compare, .compare input').attr('data-del-url', compareDelUrl);
  productObject.find('.compare, .compare input').attr('data-id', product.id);
  // Label
  if (!product.available) {
    productObject
      .find('[data-infinite-product-product-label]')
      .html(ajaxTranslations('Sold out'))
      .removeClass('hidden');
  } else {
    productObject.find('[data-infinite-product-product-label]').addClass('hidden');
  }

  // Wishlist
  if (loggedIn) {
    productObject.find('.add-to-wishlist').attr('data-url', wishlistUrl);
  }

  setTimeout(function () {
    compare();
  }, 500);
}
